//  BottomBar.js
//
//  Updated 2/2.
//
//  Abstract: Bottom navigation bar component on Login/Support/About/Register.

//  React
import React from 'react';

//  Material-ui components
import { makeStyles, CssBaseline, Grid, Link } from '@material-ui/core';

//	Define CSS styles
const useStyles = makeStyles((theme) => ({
    gridContainer: {
        marginTop: '10px',
    }
}));

export default function BottomBar(props) {

    //	CSS classes
    const classes = useStyles();

    //  Component rendering
    return (
        <>
            <CssBaseline />
            <div className={classes.gridContainer}>
            <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-end"
                spacing={10}
            >
                <Grid item>
                    <Link href="about" variant="body2" color="secondary">
                        {"About"}
                    </Link>
                </Grid>
                <Grid item>
                    <Link href="support" variant="body2" color="secondary">
                        {"Support"}
                    </Link>
                </Grid>
            </Grid>
            </div>
        </>
    );
}